import * as React from 'react';
import { connect } from 'react-redux';
import { IContactPageReducer } from '../../reducers/contactPage';
import { IPageDataReducer } from '../../reducers/pageData';
import { ContactHeader } from './components/ContactHeader';
import { AdvisorList } from './components/AdvisorList';
import { ContactForm } from '../../components/ContactForm/ContactForm';

interface StateProps {
    pageData: IPageDataReducer;
    contactPage: IContactPageReducer;
}

interface DistpachProps {}

type Props = StateProps & DistpachProps;

class ContactPageClass extends React.Component<Props, {}> {
    render() {
        return (
            <div className="contactPage">
                <ContactHeader />
                <AdvisorList contactPage={this.props.contactPage} />
                <ContactForm channel="contactForm" />
            </div>
        );
    }
}

const mapStateToProps = (state: StateProps) => ({
    pageData: state.pageData,
    contactPage: state.contactPage,
});

export const ContactPage = connect<StateProps, DistpachProps, any>(
    mapStateToProps,
    {},
)(ContactPageClass);
export default ContactPage;
